import React from "react";
import { SelectedFarmContainer } from "../../shared/crossCuttingComponents";
import { AppBar as AppBarCustomizado } from "../../layout/index";
import { Toolbar, AppBar, Typography, withStyles } from "@material-ui/core";
import { AppBarConteudoDefault } from "../../layout/";
import { t } from "../../../adapters/i18n/index";

export const FechamentoConsumoConteudoAppBar = (props) => {
  const { classes } = props;

  const renderConteudoCustomizadoAppBar = () => {
    return (
      <SelectedFarmContainer
        data-testid="containerFazendaSelecionada"
        render={(fazenda, { noFarmSelectedTitle }) => {
          const textoSecundarioAppBar = fazenda
            ? fazenda.NomeReduzido
            : noFarmSelectedTitle;
          return (
            <AppBarConteudoDefault
              data-testid="tituloAppBar"
              id="fechamentoConsumoNomeFazenda"
              tituloAppBar={textoSecundarioAppBar}
            />
          );
        }}
      />
    );
  };
  return (
    <>
      <AppBarCustomizado
        data-testid="AppBarCustomizado"
        classes={classes}
        conteudoCustomizadoAppBar={renderConteudoCustomizadoAppBar()}
        id="appBarPersonalizado"
      />
      <AppBar position="static" className={classes.AppBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.TextoAppBar} data-testid="tituloPrincipalAppBar">
            {t("supplementation:consumption-closure")}
          </Typography>
        </Toolbar>
      </AppBar>
    </>
  );
};

const styles = (theme) => {
  return {
    nomeFazenda: {
      color: "#444444",
      fontFamily: "Roboto-Medium",
      fontSize: 18,
      fontWeight: 500,
    },
    AppBar: {
      backgroundColor: "#f8f8f8",
    },
    TextoAppBar: {
      fontWeight: "normal",
      fontSize: "24px",
      letterSpacing: "-0.05px",
    },
  };
};
export default withStyles(styles)(FechamentoConsumoConteudoAppBar);
